import React, { useEffect, useState } from 'react';
import { ImageProvider } from './../ContextoGlobal';
import HeaderM1 from './Headers/HeaderM1';
import HeaderM2 from './Headers/HeaderM2';
import HeaderM3 from './Headers/HeaderM3';
import FooterM1 from './Footers/FooterM1';
import FooterM2 from './Footers/FooterM2';
import FooterM3 from './Footers/FooterM3';
import FooterM4 from './Footers/FooterM4';
import FooterM5 from './Footers/FooterM5';
import FooterM6 from './Footers/FooterM6';
import FooterM7 from './Footers/FooterM7';
import HeroM1 from './../sections/Heros/HeroM1';
import HeroM2 from './../sections/Heros/HeroM2';
import HeroM3 from './../sections/Heros/HeroM3';
import HeroM4 from './../sections/Heros/HeroM4';
import ServicoM1 from './../sections/Servicos/ServicoM1';
import ServicoM2 from './../sections/Servicos/ServicoM2';
import ServicoM3 from './../sections/Servicos/ServicoM3';
import ServicoM4 from './../sections/Servicos/ServicoM4';
import ServicoM5 from './../sections/Servicos/ServicoM5';
import ImagemTextoM1 from './../sections/ImagemTextos/ImagemTextoM1';
import ImagemTextoM2 from './../sections/ImagemTextos/ImagemTextoM2';
import ImagemTextoM3 from './../sections/ImagemTextos/ImagemTextoM3';
import ImagemTextoM4 from './../sections/ImagemTextos/ImagemTextoM4';
import TestemunhoM1 from './../sections/Testemunhos/TestemunhoM1';
import TestemunhoM2 from './../sections/Testemunhos/TestemunhoM2';
import TestemunhoM3 from './../sections/Testemunhos/TestemunhoM3';
import TestemunhoM4 from './../sections/Testemunhos/TestemunhoM4';
import CotacaoM1 from './../sections/Cotacoes/CotacaoM1';
import CotacaoM2 from './../sections/Cotacoes/CotacaoM2';
import CotacaoM3 from './../sections/Cotacoes/CotacaoM3';
import CotacaoM4 from './../sections/Cotacoes/CotacaoM4';
import PerguntasM1 from './../sections/PerguntasFrequentes/PerguntasM1';
import PerguntasM2 from './../sections/PerguntasFrequentes/PerguntasM2';
import PerguntasM3 from './../sections/PerguntasFrequentes/PerguntasM3';
import PerguntasM4 from './../sections/PerguntasFrequentes/PerguntasM4';
import ParceirosM1 from './../sections/Parceiros/ParceirosM1';
import ParceirosM2 from './../sections/Parceiros/ParceirosM2';
import AplicativoM1 from './../sections/Aplicativos/AplicativoM1';
import AplicativoM2 from './../sections/Aplicativos/AplicativoM2';
import definicoescliente from '../definicoes-cliente.json';

// Mapeamento de componentes
const componentMap: any = {
  HeaderM1: HeaderM1,
  HeaderM2: HeaderM2,
  HeaderM3: HeaderM3,
  FooterM1: FooterM1,
  FooterM2: FooterM2,
  FooterM3: FooterM3,
  FooterM4: FooterM4,
  FooterM5: FooterM5,
  FooterM6: FooterM6,
  FooterM7: FooterM7,
  HeroM1: HeroM1,
  HeroM2: HeroM2,
  HeroM3: HeroM3,
  HeroM4: HeroM4,
  ServicoM1: ServicoM1,
  ServicoM2: ServicoM2,
  ServicoM3: ServicoM3,
  ServicoM4: ServicoM4,
  ServicoM5: ServicoM5,
  ImagemTextoM1: ImagemTextoM1,
  ImagemTextoM2: ImagemTextoM2,
  ImagemTextoM3: ImagemTextoM3,
  ImagemTextoM4: ImagemTextoM4,
  TestemunhoM1: TestemunhoM1,
  TestemunhoM2: TestemunhoM2,
  TestemunhoM3: TestemunhoM3,
  TestemunhoM4: TestemunhoM4,
  CotacaoM1: CotacaoM1,
  CotacaoM2: CotacaoM2,
  CotacaoM3: CotacaoM3,
  CotacaoM4: CotacaoM4,
  PerguntasM1: PerguntasM1,
  PerguntasM2: PerguntasM2,
  PerguntasM3: PerguntasM3,
  PerguntasM4: PerguntasM4,
  ParceirosM1: ParceirosM1,
  ParceirosM2: ParceirosM2,
  AplicativoM1: AplicativoM1,
  AplicativoM2: AplicativoM2,
};

// Simulação da resposta da API
const componentesMock: ComponenteAPI[] = [
  { nome: 'Header', tipocomponente: definicoescliente.Header.Tipo, prioridade: 0 , visivel: true},
  { nome: 'Hero', tipocomponente: definicoescliente.Hero.Tipo, prioridade: 0 , visivel: true},
  { nome: 'Cotacao', tipocomponente: definicoescliente.Cotacao.Tipo, prioridade: Number(definicoescliente.Cotacao.Prioridade) , visivel: Boolean(definicoescliente.Cotacao.Visivel)},
  { nome: 'ImagemTexto', tipocomponente: definicoescliente.ImagemTexto.Tipo, prioridade: Number(definicoescliente.ImagemTexto.Prioridade) , visivel: Boolean(definicoescliente.ImagemTexto.Visivel)},
  { nome: 'Testemunho', tipocomponente: definicoescliente.Testemunho.Tipo, prioridade: Number(definicoescliente.Testemunho.Prioridade) , visivel: Boolean(definicoescliente.Testemunho.Visivel)},
  { nome: 'Servico', tipocomponente: definicoescliente.Servico.Tipo, prioridade: Number(definicoescliente.Servico.Prioridade) , visivel: Boolean(definicoescliente.Servico.Visivel)},
  { nome: 'Aplicativo', tipocomponente: definicoescliente.Aplicativo.Tipo, prioridade: Number(definicoescliente.Aplicativo.Prioridade) , visivel: Boolean(definicoescliente.Aplicativo.Visivel)},
  { nome: 'Perguntas', tipocomponente: definicoescliente.Perguntas.Tipo, prioridade: Number(definicoescliente.Perguntas.Prioridade) , visivel: Boolean(definicoescliente.Perguntas.Visivel)},
  { nome: 'Parceiros', tipocomponente: definicoescliente.Parceiros.Tipo, prioridade: Number(definicoescliente.Parceiros.Prioridade) , visivel: Boolean(definicoescliente.Parceiros.Visivel)},
  { nome: 'Footer', tipocomponente: definicoescliente.Footer.Tipo, prioridade: Number(definicoescliente.Footer.Prioridade) , visivel: Boolean(definicoescliente.Footer.Visivel)},
];

interface ComponenteAPI {
  nome: string;
  tipocomponente: string;
  prioridade: number;
  visivel: boolean;
}

const Body: React.FC = () => {
  const [componentes, setComponentes] = useState<ComponenteAPI[]>([]);

  useEffect(() => {
    const fetchData = () => {
      const componentesOrdenados = componentesMock.sort((a, b) => a.prioridade - b.prioridade);
      setComponentes(componentesOrdenados);
    };

    fetchData();
  }, []);

  return (
    <ImageProvider>
    <div className="App">
      {componentes
        .filter((componente) => componente.visivel)
        .map((componente, index) => {
          const ComponentToRender = componentMap[componente.tipocomponente];
          if (ComponentToRender) {
            return <ComponentToRender key={index}/>;
          }
          return null;
        })}
    </div>
    </ImageProvider>
  );
};

export default Body;
